export {
  default as useTelemedicineRequestViewModel,
  type UseTelemedicineRequestViewModel,
} from './useTelemedicineRequestViewModel';
